export default "__VITE_ASSET__BlzfYfyN__"